

























import {
  Vue, Component, Prop, Watch,
} from 'vue-property-decorator';
import { VbSnackbarService } from '@/shared/snackbar/snackbar.service';
import ContractService from '@/domain/contract/service/contract.service';
import ContractHistoryEntity from '@/domain/contract/entity/contract-version-history.entity';
import ContractHistoryTimeline from './contract-history-timeline.component.vue';

@Component({
  components: {
    ContractHistoryTimeline,
  },
})
export default class ContractHistoryModal extends Vue {
  @Prop({ required: true })
  value!: boolean;

  @Prop({ required: true })
  contractId!: string;

  @Prop({ required: true })
  businessUnitId!: string;

  contractHistory: ContractHistoryEntity | null = null;

  timelineKey: number = 0;

  get show(): boolean {
    return this.value;
  }

  set show(val: boolean) {
    this.$emit('input', val);
  }

  @Watch('value')
  onVisibilityChange(visible: boolean) {
    if (visible) {
      this.fetchHistory();
    }
  }

  close() {
    this.$emit('input', false);
  }

  private fetchHistory() {
    if (!this.businessUnitId || !this.contractId) return;
    ContractService.getContractHistory(this.businessUnitId, this.contractId)
      .then((response: any) => {
        this.contractHistory = ContractHistoryEntity.of(response);
        this.timelineKey += 1;
      })
      .catch((err: any) => VbSnackbarService.handleHttpError(err));
  }
}
